<template>
    <div class="modal fade modal-payin in" tabindex="-1" role="dialog" style="display: block;" v-if="action">
      <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Kapat" @click="action = false">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title" v-text="operate === '+' ? t.custom_reseller_panel.balance_in : t.custom_reseller_panel.balance_out"></h4>
          </div>
          <div class="modal-body">
            {{ t.max_earnings_per_bet_slip }}
            <MaxEarningsForm :uid="this.userId" />
            <div style="padding: 10px;"> </div>
            {{ t.max_stake_per_bet_slip }}
            <MaxStakeForm :uid="this.userId" />
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Loading from "./Loading";
  import MaxStakeForm from '@/components/form/betSlipMaxStake'
  import MaxEarningsForm from '@/components/form/betSlipMaxEarnings'
  export default {
    name: "PayinModal",
    components: {Loading, MaxStakeForm, MaxEarningsForm},
    mounted() {
      this.$bus.$on('openStakeModal', (payload) => {
        this.userId = payload.id;
        this.action = payload.action;
        this.operate = payload.operate
      })
  
      this.fetchReasons();
    },
    data() {
      return {
        api: window.api,
        t: this.$root.t,
        session: this.$root.session,
        errors: null,
        note: '',
        action: false,
        loading: false,
        reason: 0,
        reasons: []
      }
    },
    methods: {
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/components/StakeLimitModal.vue